import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme'; // Import the custom theme you created

import { SSOProvider } from './context/AuthContext';
import { ProposalInputProvider } from './context/ProposalInputContext';
import { ProposalOutputProvider } from './context/ProposalOutputContext';
import { MyProposalsProvider } from './context/MyProposalsContext';
import PrivateRoute from './utils/PrivateRoute';
import HealthCheck from './utils/HealthCheck';

import ProposalInputPage from './pages/ProposalInput';
import ProposalOutputPage from './pages/ProposalOutput';
import MyProposalsPage from './pages/MyProposals';
import PageNotFoundPage from './pages/common/PageNotFound';
import LogoutPage from './pages/common/Logout';
import UnauthorizedErrorPage from './pages/common/Unauthorized';
import ErrorPage from './pages/common/Error';
import LoginSuccessPage from './pages/common/LoginSuccess';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <BrowserRouter>
        {/* SSOProvider must wrap ALL routes exactly once */}
        <SSOProvider>
          <Routes>
            <Route path="/health" element={<HealthCheck />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/unauthorized" element={<UnauthorizedErrorPage />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/auth/callback" element={<LoginSuccessPage />} />

            <Route
              path="/"
              element={
                <ProposalInputProvider>
                  <PrivateRoute Component={ProposalInputPage} />
                </ProposalInputProvider>
              }
            />

            <Route
              path="/proposal/:id"
              element={
                <ProposalOutputProvider>
                  <PrivateRoute Component={ProposalOutputPage} />
                </ProposalOutputProvider>
              }
            />

            <Route
              path="/my-proposals"
              element={
                <MyProposalsProvider>
                  <PrivateRoute Component={MyProposalsPage} />
                </MyProposalsProvider>
              }
            />

            <Route path="*" element={<PageNotFoundPage />} />
          </Routes>
        </SSOProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;